var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg113PushPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.143,165.858l-160-160C342.393,2.107,337.305,0,332.001,0c-5.304,0-10.392,2.107-14.142,5.858 c-9.259,9.259-13.754,25.759-20.558,50.735c-7.977,29.283-18.901,69.388-38.11,88.597c-12.397,12.397-39.128,13.456-67.429,14.577 c-36.565,1.448-78.008,3.089-105.903,30.984c-7.811,7.811-7.811,20.474,0,28.284l90.35,90.35L5.937,477.78 c-7.854,7.767-7.924,20.43-0.157,28.284C9.693,510.019,14.846,512,20.001,512c5.081,0,10.165-1.925,14.063-5.78l170.429-168.551 l88.473,88.473c3.905,3.905,9.023,5.858,14.142,5.858c5.119,0,10.237-1.953,14.142-5.858c25.027-25.027,28.81-60.683,30.39-92.139 c0.554-11.032-7.939-20.424-18.971-20.978c-11.024-0.562-20.424,7.94-20.978,18.971c-0.974,19.373-2.902,35.706-7.838,48.464 L131.561,208.169c17.202-6.669,39.761-7.562,61.784-8.434c34.743-1.376,70.667-2.798,94.13-26.261 c26.725-26.725,39.264-72.757,48.42-106.368c0.995-3.653,2.097-7.7,3.229-11.699l117.47,117.47c-4,1.132-8.046,2.234-11.699,3.229 c-33.611,9.156-79.643,21.695-106.368,48.42c-7.811,7.811-7.811,20.474,0,28.284c7.811,7.81,20.474,7.811,28.284,0 c19.209-19.209,59.313-30.133,88.597-38.11c24.976-6.804,41.476-11.298,50.735-20.558c3.751-3.75,5.858-8.838,5.858-14.142 S509.894,169.608,506.143,165.858z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg113PushPin);
export default __webpack_public_path__ + "static/media/113-push-pin.a14c5069cc453e813d31b98119833754.svg";
export { ForwardRef as ReactComponent };